import { isNil } from '@soltalabs/ramda-extra'
import React, { Component } from 'react'

import { redux } from './redux'
import { JobListView } from './view'

class JobsListContainer extends Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { jobList } = this.props
    const sourceJob = jobList[oldIndex]
    const destinationJob = jobList[newIndex]

    const source = {
      id: sourceJob.id,
      priorityNumber: destinationJob.priorityNumber,
    }
    const destination = {
      id: destinationJob.id,
      priorityNumber: sourceJob.priorityNumber,
    }

    this.props.dispatchReorderJobs(source, destination)
  }

  handleScroll = (e) => {
    const {
      sortBy,
      nextPageId,
      dispatchFetchNextJobs,
      isFetchJobsLoading,
      isFetchNextJobsLoading,
    } = this.props
    const { scrollHeight, scrollTop, clientHeight } = e.target
    const isBottom = scrollHeight - scrollTop === clientHeight

    const shouldFetchNextJobs =
      isBottom && !isNil(nextPageId) && !isFetchJobsLoading && !isFetchNextJobsLoading

    if (shouldFetchNextJobs) {
      dispatchFetchNextJobs(sortBy, nextPageId)
    }
  }

  render() {
    return (
      <JobListView
        {...this.props}
        onSortEnd={this.onSortEnd}
        onScroll={this.handleScroll}
      />
    )
  }
}

const JobsList = redux(JobsListContainer)

export { JobsList }
